import { useEffect, useRef } from "react";

const eventsList = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
  "touchstart",
];

const SessionTimeout = ({ children, userToken }) => {
  const timerRef = useRef();

  const removeListeners = () => eventsList.forEach((item) => window.removeEventListener(item, handleListener));

  const handleLogout = () => {
    removeListeners();
    window.location.href = "/logout";
  }

  // when component mounts, it adds an event listeners to the window
  // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after t secs of inactivity resets.
  // However, if none of the event is triggered within t secs, that is app is inactive, the app automatically logs out.
  // useEffect(() => {
  //   if (userToken) {
  //     clearTimeout(timerRef.current);
  //     if (userToken) eventsList.forEach((item) => window.addEventListener(item, handleListener));

  //     return () => removeListeners();
  //   }
  // }, [userToken]);

  const handleListener = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      // handleLogout();
    }, 300000);
  };

  return children;
};

export default SessionTimeout;